import * as React from 'react';

import {FeatureGateModalWrapper} from '../limits/feature-gates/feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    isAdmin: boolean;
};

export function SchedulerFullFeatureGateModal(props: Props) {
    return (
        <FeatureGateModalWrapper
            title='Personalize your meeting pages'
            description='Unlock new Scheduler features that allow you to better manage interactions with customers'
            onClose={props.onClose}
            isOpen={props.isOpen}
            bullets={[
                'Edit your meeting links and utilize custom domains',
                'Personalize your meeting pages with an avatar and company logo',
                'Hide certain meetings from your public meeting scheduler page',
            ]}
            feature={props.isAdmin ? 'schedulerFull' : 'schedulerFullNonAdmin'}
        />
    );
}
